import React from 'react';
import ListFetchErrorStateBase from './list-fetch-error-state-base';
import { COMMENT_NOT_FOUND } from '../../common/constants/data-hooks';
const CommentNotFoundState = ({ onRetry }) => {
    return (React.createElement(ListFetchErrorStateBase, { onRetry: onRetry, dataHook: COMMENT_NOT_FOUND, primaryKey: "empty-state.thread-comment-not-found", secondaryKey: "empty-state.thread-comment-not-found-subtext", ctaKey: "empty-state.thread-comment-not-found-refresh" }));
};
export default CommentNotFoundState;
//# sourceMappingURL=comment-not-found-state.js.map